<template>
  <spin-modal :title="title" :loading="loading" v-if="showModal" @close="closeModal"></spin-modal>
  <div class="title">Let us answer your questions!</div>
  <div class="d1">
    <div class="d1a">
      <div class="d2">
        <div class="d2a">    
          <div class="d2a1">
            <div class="d2a1a">Call, Text, or Email Anytime</div>                           
            <div class="d2a1b">
              <div class="d2a1b1"  @click="openEmail">
                <img class="img1" src="../assets/emailIcon.png" alt="Email Icon" />
                <div class="d2a1b1a">eric.k@inyourhands-llc.com</div>
              </div>
              <span style="height:40px;" v-if="isMobile"></span>
              <div class="d2a1b1" @click="callPhone">
                <img class="img1" src="../assets/phoneIcon.png" alt="Phone Icon"/>
                <div class="d2a1b1a">+1-970-373-7456</div>
              </div>
            </div> 
          </div>
          <div class="d2a2">
            <div class="d2a1a">Connect With Us On The Web</div>
            <div class="d2a2b">
              <a href="https://www.facebook.com/profile.php?id=61575234548015" target="_blank">
                <img class="img1" src="../assets/facebookIcon.png" alt="Facebook Icon"/>
              </a>
              <!-- <a href="https://www.instagram.com/rexrothdev/" target="_blank">
                <img class="img1" src="../assets/instagramIcon.png" alt="Instagram Icon" />
              </a>
              <a href="https://www.linkedin.com/in/andrewrexroth/" target="_blank">
                <img class="img1" src="../assets/linkedinIcon.png" alt="LinkedIn Icon"/>
              </a> -->
            </div>
          </div>
        </div>                  
      </div>      
      <div class="d3">
        <div class="d3a">
          <div class="d3a1">
              <div class="d3a1a">
                  <div class="d3a1a1">Message Us</div>
                  <div class="d3a1a2">Please leave us a message and your preferred form of contact and we will get back to you!</div>
              </div>
          </div>
          <div class="d3a2">
            <div class="contactForm">
              <form class="contactForm1" @submit.prevent="sendMessage">
                  <label for="firstname">First Name:</label>
                  <input v-model="firstname" id="firstname" name="firstname"/>
                  <div v-if="warnings[0]" class="warningMsg">Please enter your first name</div>
                  <div v-else class="warningMsg"></div>
                  <label for="lastname">Last Name:</label>
                  <input v-model="lastname" id="lastname" name="lastname"/>
                  <div v-if="warnings[1]" class="warningMsg">Please enter your last name</div>
                  <div v-else class="warningMsg"></div>
                  <label for="phone">Phone:</label>
                  <input v-model="phone" id="phone" type="phone" name="phone"/>
                  <div v-if="warnings[2]" class="warningMsg">Please enter your phone number</div>
                  <div v-else class="warningMsg"></div>
                  <label for="email">Email:</label>
                  <input v-model="email" id="email" type="email" name="email"/>
                  <div v-if="warnings[3]" class="warningMsg">Please enter your email address</div>
                  <div v-else class="warningMsg"></div>
                  <label for="message">Message:</label>
                  <textarea v-model="message" id="message" class="messageBlock" name="message" />
                  <div v-if="warnings[4]" class="warningMsg">Please enter a message</div>
                  <div v-else class="warningMsg"></div>
                  <div class="d3a2a">
                    <div class="g-recaptcha" :data-sitekey="siteKey" ref="recaptcha"></div>
                  </div>
                  <div v-if="warnings[5]" class="warningMsg">Please complete the Captcha</div>
                  <div v-else class="warningMsg"></div>
                  <button  type="submit" value="Send" >SEND!</button>
                  <div v-if="emailStatus==='success'" :class="['emailStatus','emailSuccess']">Your message has been sent, Thanks!</div>
                  <div v-else-if="emailStatus==='falure'" :class="['emailStatus','emailFailure']">Sorry, your message failed to send</div>
                  <div v-else class="emailStatus"></div>
              </form>
            </div>
          </div>
        </div>
      </div>   
    </div> 
  </div>
</template>

<script>
  // import emailjs from '@emailjs/browser';
  import { init, send as emailjsSend } from '@emailjs/browser'
  import SpinModal from './SpinModal.vue';
  // import { useReCaptcha } from 'vue-recaptcha-v3';
  export default {
  components: { SpinModal },
    name: 'contact',
    data () {
      return {
        warnings: [],
        firstname: '',
        lastname: '',
        email: '',
        phone: '',
        message: '',
        emailStatus: '',
        title: 'Sending Message...',
        loading: true,
        showModal: false,
        isMobile: false,
        minw: 0,
      }
    },
    mounted() {
      this.windowSize();
      window.addEventListener('resize', this.windowSize);

      init(process.env.VUE_APP_EMAILJS_PUBLIC_KEY);
      this.updateViewport();    
      window.addEventListener('resize', this.updateViewport); 

      if (window.grecaptcha?.render) this.renderRecaptcha();
      else window.__renderVueRecaptcha = () => this.renderRecaptcha();
    },
    beforeUnmount() {
      window.removeEventListener('resize', this.updateViewport);
      window.removeEventListener('resize', this.windowSize);
    },
    computed: {
      siteKey() {
        return process.env.VUE_APP_RECAPTCHA_SITE_KEY;
      }
    },
    methods: {
      windowSize () {
        if (window.innerWidth <= 900) {
          this.isMobile = true
        } else {
          this.isMobile = false
        }
      },
      timeout (ms) {
        return new Promise(resolve => setTimeout(resolve, ms))
      },
      isCaptchaReady() {
        return window.grecaptcha && window.grecaptcha.getResponse && window.grecaptcha.getResponse() !== '';
      },
      renderRecaptcha() {
        if (this.widgetId != null) return;                // avoid double-render
        this.widgetId = window.grecaptcha.render(this.$refs.recaptcha, {
          sitekey: this.siteKey
        });
      },
      closeModal () {
        this.showModal = false
      },
      callPhone () {
        // if (this.isMobile) {
          window.open('tel:+19703737456','_blank');
        // }
      },
      openEmail () {
        document.location = 'mailto:eric.k@inyourhands-llc.com'
      },
      async sendMessage () {
        this.emailStatus = ''
        let send = true

        this.warnings[0] = this.firstname === ''
        this.warnings[1] = this.lastname === ''
        this.warnings[2] = this.phone === ''
        this.warnings[3] = this.email === ''
        this.warnings[4] = this.message === ''

        // Get captcha token and validate
        const token = window.grecaptcha.getResponse();
        
        this.warnings[5] = token === ''
        
        // Additional captcha validation
        if (!token || token === '') {
          console.error('Captcha not completed');
          this.warnings[5] = true;
          send = false;
        }

        for (let i = 0; i < 6; i++) {
          if (this.warnings[i] === true) {
            send = false
          }
        }
        if (send === true) {
          // Double-check captcha is ready
          if (!this.isCaptchaReady()) {
            console.error('Captcha not ready, please complete it first');
            this.warnings[4] = true;
            this.showModal = false;
            return;
          }

          this.loading = true
          this.title = 'Sending Message...'
          this.showModal = true

          try {
            const response = await emailjsSend(
              process.env.VUE_APP_EMAILJS_SERVICE_ID, 
              process.env.VUE_APP_EMAILJS_TEMPLATE_ID, 
              {
                firstname: this.firstname,
                lastname: this.lastname,
                email: this.email,
                phone: this.phone,
                message: this.message,
                'g-recaptcha-response': token
              }, 
              process.env.VUE_APP_EMAILJS_PUBLIC_KEY
            );
            this.loading = false
            
            if (response && response.status === 200) {
              this.emailStatus = 'success'
              this.title = 'Your message has been sent!'
              this.firstname = ''
              this.lastname = ''
              this.phone=''
              this.email = ''
              this.message = ''
              // Reset captcha
              window.grecaptcha.reset();
            } else {
              this.emailStatus = 'failure'
              this.title = 'Sorry, your message failed to send'
            }

            // Wait 2 seconds before closing modal
            await this.timeout(2000)
          
          } catch (error) {
            console.error('EmailJS error:', error);
            this.loading = false
            this.emailStatus = 'failure'
            this.title = 'Sorry, your message failed to send'
            // Wait 2 seconds before closing modal even on error
            await this.timeout(2000)
          } finally {
            this.showModal = false
          }
        }
      },
      updateViewport() {
      this.minw = window.screen.width*.75 + 'px';             
    },
    },
    created () {
      for (let i = 0; i < 4; i++){
        this.warnings.push(false);
      }
    }
  }
</script>

<style scoped>
input {
  box-sizing: border-box;  
  padding: .9em .3em;
}
textarea {
  box-sizing: border-box;
  padding: .9em;
}
.img1 {
  width: 55px;
  height: 55px;
  margin: 10px;
}
.img1:hover {
  transform: scale(1.2);
}
.d1 {
  background-color:v-bind(colorBlue1);
  width: 100%;
  font-family: 'Akatab';
  color: white;
  margin-top: 50px;
  min-width: v-bind(minw);
}
.d1a {
  width:80%;
  margin-left:10%;  
  /* border:5px solid white;   */
  border-radius: 10px;
  overflow: hidden;
  box-sizing:border-box;
  margin-bottom: 40px;
}
.d2 {
    width:100%;    
}
.d2a {
    background-color:v-bind(colorBlue2);    
    display:flex;
    justify-content: space-evenly;
}
.d2a1,.d2a2 {
  width: 50%;
  display: flex;    
  flex-direction: column;  
  margin: 20px 0;

}
.d2a1a {
  font-size:30px;
  text-align: center;
  margin-bottom: 30px;
}
.d2a1b {
  display: flex;
  width: 100%;
  justify-content: space-evenly;
}
.d2a1b1:hover{
    background-color:rgb(143, 165, 199);
    cursor:pointer;
    border-radius:12px;
}
.d2a1b1 {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 10px;
}
.d2a2b {
  display: flex;
  justify-content: center;
  align-items: center;
}

.d2a1b1a {
    color:white;
    text-decoration: underline;
}

.d3 {
    width:100%;
    color: v-bind(colorBlue2);
    font-family: 'Akatab';    
}

.d3a {    
    background-color: white;
    box-sizing:border-box;
    display:flex;
    padding-top: 40px ;
  }
.d3a1 {
    width:50%;
    /* height:stretch; */
    border-right:1px solid v-bind(colorBlue2);
    margin-top:3%;
    margin-bottom: 6%;
    box-sizing: border-box;    
}
.d3a1a {
    margin-top: 20%;
    margin-left:10%;
    margin-right:8%;
}
.d3a1a1 {
    font-size:2em;
    margin-bottom:10%;
}
.d3a1a2 {
    font-size:1.2em;
}
.d3a2 {
    width:50%;
    height:100%;
}
.d3a2a {
  width: 100%;
  display: flex;
  justify-content: center;
}
.contactForm {
    width:100%;
    height:100%;
    display:flex;
    justify-content: center;
    align-items: center;
    font-family: 'Akatab';
    font-size: 20px;
}
.contactForm1 {
  position: relative;
  width:80%;
  height:80%;
  display: flex;
  flex-direction: column;
}
.contactForm1 input {
    width:100%;
    height:1.5em;
    color:v-bind(colorBlue2);
}
.contactForm1 button {
    width:80%;
    height:2em;
    margin-left:10%;
    color:white;
    /* font-size:1.5em; */
    font-size:1.2em;

    background-color:v-bind(colorBlue2);
    border-radius: 10px;
}
.contactForm1 button:hover {
  cursor: pointer;
}
.contactForm1 textarea {
    width:100%;
    padding:0;
    margin:0;
    font-family: 'Akatab';
}
.g-recaptcha {
  width: fit-content;
}
.warningMsg {
    color:red;
    font-size:.7em;
    height:2em;
}

.messageBlock {
    height:100px;
}
.emailStatus {
    height:25px;
    width:100%;
    /* background-color:green; */
    margin-top:5px;
    text-align:center;
}
.emailSuccess {
    color:green;
}
.emailFailure {
    color:red;
}
.title {
  font-family: 'Anonymous Pro';
  font-size: 60px;
  color: v-bind(colorRed);
  position:absolute;
  min-width: v-bind(minw);
  top: 130px;
  display: flex;
  justify-content: center;
  width: 100%;
  text-shadow:0 4px 4px rgba(0, 0, 0, 0.35);
  text-align: center;
}
@media only screen and (max-width: 900px) {
  .title {
    font-size: 40px;
    top: 170px;
  }
  .d1 {
    margin-top: 110px;
  }
  .d1a {
    width: 90%;
    margin-left: 5%;
  }
  .d2a {
    flex-direction: column;
  }
  .d2a1, .d2a2 {
    width: 100%;
  }
  .d2a1a {
    font-size: 25px;
  }
  .d2a1b {
    flex-direction: column;
    width: 90%;
    margin-left: 5%;
  }
  .d2a1b1 {
    background-color:rgb(143, 165, 199);
    cursor:pointer;
    border-radius:12px;
  }
  .d3a {
    flex-direction: column;    
    padding: 0;
  }
  .d3a1, .d3a2 {
    width: 100%;
    border: none;
  }
  .d3a1a {
    margin-top: 30px;
  }
}
</style>